<template>
  <button class="menu-btn" @click="drawer = !drawer">
    <el-drawer
      size="100%"
      :append-to-body="true"
      :visible.sync="drawer"
      direction="rtl"
      :modal="false"
      custom-class="mobile-menu"
    >
      <template #title>
        <div class="logo" @click="gotoHomePage">
          <img src="@/assets/images/jncyLayout/logo.png" />
        </div>
      </template>

      <ul class="menus">
        <li
          v-for="(item, index) in MenuList"
          :key="index"
          @click="gotoPage(item)"
          :class="[item.activePath.includes(currentHtmlName) && 'on']"
        >
          {{ item?.label }}
        </li>
        <li @click="toPersonalCenter">个人中心</li>
      </ul>
      <div class="bottom">
        <button v-if="userStore.isLogin" class="loginout" @click="toSSOLogout">退出登录</button>
        <button v-else class="login" @click="toSSOLogin">登录</button>
      </div>
    </el-drawer>
  </button>
</template>
<script setup lang="ts">
import './mobile.scss';
import { siteURL } from '@/configs/Constant';
import { toSSOLogin, toPersonalCenter, toSSOLogout } from '@/configs/coalEduAuth';
import { ref } from 'vue';
import { MenuList } from '../Menu';
import { useUserStore } from '@/stores/user';
import { gotoHomePage } from '@/logic/gotoPage';
const drawer = ref(false);

const currentHtmlName = location.pathname.split('/').pop();
const userStore = useUserStore();

const gotoPage = (data: any) => {
  location.href = (data.isPublicDomain ? siteURL : `./`) + data.path;
};
</script>

<style scoped lang="scss">
.menu-btn {
  // background: linear-gradient(135deg, #3956eb, #2c44b3);
  border: none;
  border-top: 1px solid #2c44b3;
  border-bottom: 1px solid #2c44b3;
  background-color: transparent;
  outline: none;
  width: 0.42rem;
  height: 0.38rem;
  position: relative;
  padding: 0;

  &::before,
  &::after {
    content: '';
    height: 1px;
    position: absolute;
    left: 0;
    width: 100%;
    background-color: #2c44b3;
  }
  i {
    font-size: 0.54rem;
    color: #ffffff;
  }
}

.logo {
  img {
    width: 4.6rem;
    height: 0.6rem;
  }
}
.menus {
  list-style-type: none;
  margin: 0;
  padding: 0;
  li {
    font-size: 16px;
    padding: 12px 20px;
    color: #333;
    transition:
      background-color 0.3s,
      transform 0.2s;
    &:active {
      background-color: #e0e7ff;
      transform: scale(1.05);
    }
    &.on {
      background: linear-gradient(135deg, #3956eb, #2c44b3);
      color: #ffffff;
    }
  }
}
.bottom {
  display: flex;
  justify-content: center;
  padding: 10px 0;
  margin-top: 50px;
  button {
    background: linear-gradient(135deg, #3956eb, #2c44b3);
    color: #ffffff;
    border: none;
    padding: 8px 20px;
    width: 120px;
    border-radius: 25px;
    cursor: pointer;
    font-size: 16px;
    transition:
      background-color 0.3s,
      transform 0.2s;
    &:active {
      background-color: #2c44b3;
      transform: translateY(-2px);
    }
    &.loginout {
      background: linear-gradient(135deg, #f56c6c, #f57777);
    }
  }
}
</style>
